export default __webpack_public_path__ + "static/media/metamask-network-goerli.d493a3fa.png";